<template>
  <DetailCard id="detail-ehr-technical">
    <template #heading>
      <span class="pi pi-tools"></span>
      <a :href="getEhrTechnicalExternalUrl" target="_blank">
        {{ $t(`messages.detail.ehrTechnical.title`) }}
      </a>
    </template>
    <div
      v-for="field in fields"
      :key="field"
      class="grid grid-cols-2 py-3 border-b border-gray-200 dark:border-gray-700 last:border-b-0 px-4"
    >
      <label :for="field" class="font-bold">
        {{ $t(`messages.detail.ehrTechnical.${field}`) }}
      </label>
      <PredefinedValuesInputComponent
        v-if="predefined.includes(field)"
        category="ehrTechnical"
        :name="field"
        :append-on-select="true"
        v-model="ehrTechnical[field]"
        @update:model-value="evaluationStore.save({ technical: { [field]: $event } })"
      />
      <span v-else>{{ ehrTechnical[field] }}</span>
    </div>
  </DetailCard>
</template>

<script setup>
import { storeToRefs } from 'pinia'
import { computed, readonly } from 'vue'
import PredefinedValuesInputComponent from '@/components/PredefinedValuesInputComponent.vue'
import { useDetailStore } from '@/stores/useDetailStore'
import { useEvaluationStore } from '@/stores/useEvaluationStore'
import DetailCard from '../DetailCard.vue'

const store = useDetailStore()
const evaluationStore = useEvaluationStore()

const { ehrTechnical, ehrId } = storeToRefs(store)

const fields = readonly([
  'ehitisealune-pind',
  'maapealse-osa-alune-pind',
  'maapealseid-korruseid',
  'maa-alused-korrused',
  'lift',
  'snp',
  'koetav-pind',
  'eluruumide-pind',
  'mitteeluruumide-pind',
  'hoone-maht',
  'maapeal-osa-maht',
  'yldkasutatav-pind',
  'tehnopind',
  'pindalade-vastavus',
  'markused',
])

const predefined = readonly(['pindalade-vastavus', 'markused'])

const getEhrTechnicalExternalUrl = computed(() => {
  return 'https://ehr.ee/app/link/b/' + ehrId.value
})
</script>
